export const formatDate = ({ days=0 }) => {
    const date = new Date()
    date.setDate(date.getDate() + days)
    const addZero = (number) => number <= 9 ? `0${number}` : number
    const day = addZero(date.getDate())
    const month = addZero(date.getMonth()+1)
    const year = (date.getFullYear())
    return `${day}.${month}.${year}`
}